import React from 'react';
import InfoIcon from '@material-ui/icons/Info';

import './EditModeMsg.css';

const EditModeMsg = () => (
  <div className="container editmodemsg flex flex-row center">
    <InfoIcon scale={20} color="disabled" className="icon" />
    <div>
      You are in edit mode. Manage the stops by clicking on the red dots.
      <br />
      You can switch between routes by clicking route label.
    </div>
  </div>
);

export default EditModeMsg;
